import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormDateField, FormTextArea } from '@eas/common-web';
import { useCommonHistoryDescriptors } from '@composite/history/history-common-descriptors';
import { HistoryField } from '../../composite/history/history-field';

export function Fields() {
  const historyDescriptors = useCommonHistoryDescriptors();

  return (
    <>
      <FormDateField
        name="date"
        required
        label={
          <FormattedMessage
            id="ES__DICT_HOLIDAYS__DETAIL__FIELD_LABEL__DATE"
            defaultMessage="Datum"
          />
        }
      />
      <FormTextArea
        name="description"
        label={
          <FormattedMessage
            id="ES__DICT_HOLIDAYS__DETAIL__FIELD_LABEL__DESCRIPTION"
            defaultMessage="Popis"
          />
        }
      />
      <HistoryField descriptors={historyDescriptors} />
    </>
  );
}
